export const scrollIntoView = (element: $TSFixMe, alignToTop = false) => element && element.scrollIntoView(alignToTop);

export const scrollIntoViewWithOptions = (
    element: Element,
    options: ScrollIntoViewOptions = { behavior: 'smooth', block: 'nearest', inline: 'nearest' }
) => element && element.scrollIntoView(options);
